import React from 'react';
import { createRoot } from 'react-dom/client';
import 'rrweb/dist/style.css';
import './observatory.css';
import { Observatory } from './Observatory.tsx';

const root = document.getElementById('root');
if (!root) throw new Error('No Observatory root.');
createRoot(root).render(<React.StrictMode><Observatory /></React.StrictMode>);

